module.exports = __webpack_public_path__ + "static/media/horn-fail.2d1ac5c4.wav";